import clsx from 'clsx';
import React, {} from 'react';
import './ShadedBlock.scss';
const ShadedBlock = ({ children, className, intent }) => (React.createElement("div", { className: clsx('shaded-block', className, intent) }, children));
export default ShadedBlock;
